import React, { useEffect } from "react";
import ReactDOM from 'react-dom';
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import $ from "jquery"; // Import jQuery
import CustomNeed from "../component/CustomNeed";

const SecurityMonitoring = () => {
    useEffect(() => {
    
        const win = window;
    
        function isElementVisible($el) {
          const viewTop = win.scrollY;
          const viewBottom = viewTop + window.innerHeight;
          const elTop = $el.offset().top;
          const elBottom = elTop + $el.height();
          return elBottom <= viewBottom && elTop >= viewTop;
        }
        $('.why_coustom_app').parents('body').find('header').addClass('white_header');  
        function addAnimation($el, delay) {
            
          setTimeout(() => {
            $el.addClass("come-in");
            $el.attr("class", "webflow_circle come-in");
          }, delay);
        }
    
        const allMods1 = Array.from(document.querySelectorAll(".webflow_circle"));
        const allMods2 = Array.from(document.querySelectorAll(".html_circle"));
        const allMods3 = Array.from(document.querySelectorAll(".css_circle"));
        const allMods4 = Array.from(document.querySelectorAll(".js_circle"));
    
        win.addEventListener("scroll", () => {
          allMods1.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods2.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods3.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods4.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
        });
    
        const handleScroll = () => {
          const offset = window.pageYOffset;
          const wheight = window.innerHeight;
          const html = document.documentElement;
          const docheight = Math.max(
            document.body.scrollHeight,
            document.body.offsetHeight,
            html.clientHeight,
            html.scrollHeight,
            html.offsetHeight
          );
          let progress = (offset / (docheight - wheight)) * 3000;
    
          // Give the line a CSS gradient based on scroll position
          progress = 3000 - progress * 1.6;
    
          // Update the SVG element with the new stroke-dashoffset
          const fillingPath = document.getElementById("filling_path");
          if (fillingPath) {
            fillingPath.setAttribute("stroke-dashoffset", progress);
          }
        };
    
        // Add scroll event listener when the component mounts
        window.addEventListener("scroll", handleScroll);
    
        // Remove the event listener when the component unmounts
        return () => {
            
          window.removeEventListener("scroll", handleScroll); 
        };
      }, []);
      const [ref, inView] = useInView({
        triggerOnce: true, // Ensures the animation occurs only once
        threshold: 0.2, // Change as needed; it's the percentage of the element's visibility to trigger the animation
      });
    
      const leftAnimation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut" }, // Define your desired animation properties
        },
      };
    
      const image1Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 0.5 }, // Define your desired animation properties
        },
      };
    
      const image2Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 1 }, // Define your desired animation properties
        },
      };
    
      const image3Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 1.5 }, // Define your desired animation properties
        },
      };
       
      return (
        <>
          <div
            className="inner_banner service-banner"
            style={{ backgroundImage: "url(/assets/images/site/dedicated-dev-2.png)" }}
          >
            <div className="wrapper">
              <div className="banner_detail_1">
                <div className="details-ser">
                  <h1 id="heading_line">Security Monitoring: Safeguard Against Threats with Proactive Monitoring and Mitigation</h1>
                  <h2 id="sub_heading1">
                  In today’s digital landscape, where cyber threats are becoming increasingly sophisticated, <strong>security monitoring</strong> has become a crucial aspect of maintaining a safe and secure website. Whether you're managing a small blog or a large e-commerce platform, safeguarding your site from potential <strong>cyberattacks, data breaches</strong>, and <strong>malicious activities</strong> is paramount. <strong>Proactive monitoring and mitigation</strong> are essential to not only detect threats but also to prevent them before they can cause harm.
                  </h2>
                 
                </div>
              </div>
            </div>
            </div>
            <div className="why_coustom_app">
                <div className="wrapper">
                <h3>Why <span>Security Monitoring</span> is Crucial for Your Website</h3>
                <h4>1. Early Threat Detection</h4>
                <p>The sooner you detect a threat, the easier it is to mitigate and prevent any damage. Hackers and cybercriminals often operate stealthily, attempting to infiltrate your website without being noticed. <strong>Proactive security monitoring</strong> allows you to detect unusual activities or vulnerabilities early and take action before they escalate into major problems. Without security monitoring, you may not even realize your site is compromised until it’s too late.</p>

                <h4>2. Real-Time Alerts for Quick Action</h4>
                <p>Security monitoring provides <strong>real-time alerts</strong> when suspicious activities are detected. These alerts could be related to unauthorized login attempts, malware, brute force attacks, or unusual spikes in traffic that could indicate a <strong>DDoS (Distributed Denial of Service) attack.</strong> With immediate notifications, you can quickly address issues and prevent potential damage, ensuring that your website remains secure.</p>

                <h4>3. Prevent Data Breaches</h4>
                <p>Data breaches can have devastating consequences, including loss of sensitive information, damage to your reputation, and legal consequences. <strong>Security monitoring</strong> helps prevent breaches by continuously scanning for vulnerabilities and threats. By actively monitoring your site’s security, you ensure that any attempt to access private data is blocked before it can succeed.</p>

                <h4>4. Compliance with Regulations</h4>
                <p>Many industries are subject to strict regulations when it comes to <strong>data protection</strong> (such as GDPR, HIPAA, PCI-DSS). Security monitoring plays a vital role in maintaining compliance by ensuring that your website’s security practices meet legal standards. Consistent monitoring and proactive mitigation of threats help demonstrate your commitment to protecting user data and avoiding regulatory fines.</p>

                <h4>5. Protecting Your Reputation</h4>
                <p>A hacked website can damage your <strong>brand’s reputation</strong>, leading to a loss of customer trust and loyalty. Visitors expect that the websites they interact with will keep their data secure. Proactive <strong>security monitoring</strong> reduces the risk of security breaches, ensuring that your customers feel safe and confident when interacting with your site.</p>
                
                <h3>Best Practices for Implementing <span>Proactive Security Monitoring</span></h3>
                <h4>1. Use Web Application Firewalls (WAFs)</h4>
                <p>A <strong>Web Application Firewall (WAF)</strong> is one of the first lines of defense against online threats. It filters and monitors HTTP traffic between the website and its users, blocking malicious traffic and attacks before they can reach your site. Implementing a WAF can protect your site from <strong>SQL injection attacks, cross-site scripting (XSS)</strong>, and other common web application threats.</p>

                <h4>2. Set Up Intrusion Detection Systems (IDS)</h4>
                <p>An <strong>Intrusion Detection System (IDS)</strong> constantly scans your website for signs of malicious activity or intrusions. It monitors network traffic, identifies potential threats, and notifies you when something unusual is detected. By using an IDS, you can detect <strong>attempted hacking, unauthorized access</strong>, and <strong>anomalies</strong> that may go unnoticed by manual monitoring.</p>

                <h4>3. Implement Automated Malware Scanning</h4>
                <p>Malware is a significant threat to websites, and without regular scanning, your site may unknowingly be hosting malicious software that can compromise user data. <strong>Automated malware scanning</strong> helps detect harmful code or software on your site. By scheduling regular scans, you ensure that any malware is caught early and removed before it causes any damage.</p>

                <h4>4. Monitor Login Attempts and User Activity</h4>
                <p>One of the most common ways hackers attempt to breach a website is through <strong>brute force attacks</strong>—repeatedly trying different passwords until they find the right one. By monitoring <strong>login attempts, user activity</strong>, and suspicious behaviors (such as multiple failed logins), you can block malicious users before they gain access to your website. Use <strong>two-factor authentication (2FA)</strong> and <strong>IP blocking</strong> to strengthen login security further.</p>

                <h4>5. Regularly Update Software & Plugins</h4>
                <p>Keeping your website's <strong>CMS</strong> (Content Management System), <strong>themes</strong>, and <strong>plugins</strong> up to date is crucial for security. Many cyberattacks exploit vulnerabilities in outdated software. Regular updates often include <strong>security patches</strong> that address newly discovered vulnerabilities. By ensuring that your software is always updated, you help mitigate the risk of a cyberattack.</p>

                <h4>6. Use Secure Sockets Layer (SSL) Encryption</h4>
                <p>Implementing <strong>SSL encryption</strong> on your website helps ensure that any data transmitted between your website and its visitors is secure. SSL certificates encrypt sensitive information, such as <strong>credit card numbers, personal data</strong>, and <strong>login credentials</strong>, protecting it from interception by malicious actors. SSL encryption is especially important for e-commerce sites and any website that collects user data.</p>

                <h4>7. Conduct Vulnerability Scanning</h4>
                <p>Vulnerability scanning tools automatically check your website for security weaknesses and known vulnerabilities. These tools provide a detailed report of any issues found, such as outdated software, unpatched security holes, or weak configurations. Regular vulnerability scans help you stay ahead of potential threats and fix issues before they can be exploited by cybercriminals.</p>

                <h4>8. Backup Your Website Regularly</h4>
                <p>While security monitoring is essential for <strong>threat detection</strong> and <strong>mitigation</strong>, it’s also critical to have a backup strategy in place. Regularly backing up your website ensures that in the event of a cyberattack, you can restore your website quickly and minimize downtime. Automated backups, combined with proactive security monitoring, provide comprehensive protection for your website.</p>

                <h3>Benefits of <span>Proactive Security Monitoring</span></h3>
                <h4>1. Enhanced Protection Against Emerging Threats</h4>
                <p>Cybersecurity is a constantly evolving field, with new threats emerging all the time. Proactive monitoring ensures that your website is continuously safeguarded against the latest vulnerabilities, threats, and attack techniques.</p>

                <h4>2. Reduced Risk of Downtime</h4>
                <p>With real-time alerts and quick response times, security monitoring minimizes the risk of significant downtime due to security incidents. By addressing issues as soon as they arise, you prevent attackers from exploiting vulnerabilities and keep your website running smoothly.</p>

                <h4>3. Increased Trust and Confidence</h4>
                <p>Websites that implement proactive security measures demonstrate to users that they care about protecting their data. <strong>Trust badges, SSL encryption</strong>, and visible security protocols can encourage users to engage with your site confidently, knowing their personal information is safe.</p>

                <h4>4. Lower Costs of Security Breaches</h4>
                <p>The costs associated with data breaches can be devastating for businesses. These costs include legal fees, lost revenue, reputational damage, and regulatory fines. By monitoring your website for threats and taking action early, you minimize the risk of a breach and avoid these hefty expenses.</p>

                <h3>Conclusion: Stay Ahead of Cyber Threats with <span>Proactive Security Monitoring</span></h3>


                <p>Security monitoring is no longer a luxury—it’s a necessity for any website that handles user data or conducts business online. By implementing <strong>proactive security measures</strong> such as real-time alerts, malware scanning, and vulnerability scanning, you can detect and mitigate threats before they cause significant harm. A <strong>secure website</strong> not only protects your business but also ensures the safety of your visitors, fostering trust and loyalty.</p>
                <p>Investing in robust security monitoring is one of the best ways to safeguard your website from cyber threats, maintain compliance with regulations, and ensure business continuity. Don’t wait for a security breach to happen—take proactive steps today to protect your website.</p>

                </div>
            </div>
            <div className="why_us">
            <div className="wrapper">
              <h4>Benefits of Working with CodeFlix</h4>
              <div className="col_row">
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg1.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us5.svg" alt="" />
                  </div>
                  <hr />
                  <h3>End-to-End Solutions</h3>
                  <p>
                    From ideation to deployment, we handle every aspect of the
                    development process.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg2.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us6.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Agile Methodology</h3>
                  <p>
                    Ensuring flexibility and faster delivery without compromising on
                    quality.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg3.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us7.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Experienced Team</h3>
                  <p>
                    A skilled team of developers, designers, and project managers
                    dedicated to your success.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg4.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us8.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Client-Centric Approach</h3>
                  <p>
                    Regular communication and collaboration to align the project
                    with your vision.
                  </p>
                </div>
              </div>
           <br />
            </div>
            </div>
            <div className="let_build">
                <div className="wrapper">
                <h4>Let’s Build <span> Your App Together </span></h4>
                
                <p>
                Whether you’re a startup looking to disrupt the market or an
                established enterprise aiming to enhance operational efficiency,
                CodeFlix is here to bring your vision to life. Let’s create a
                custom mobile app that drives results and delights your users.{" "}
                <br />
                Contact Us today to get started on your mobile app development
                journey.
                </p>
                </div>
            </div>
        </>
      );
};
export default SecurityMonitoring;
